<script lang="ts">
  import CloseButton from "../../components/CloseButton.svelte";
</script>

<div class="h-full flex flex-col gap-4">
  <div>
    Thank you. We will run a search for your agreement(s) and get back to you shortly.
  </div>
</div>

<div class="floating-footer justify-end">
  <CloseButton class="btn-primary" />
</div>
